import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  //{ path: '/main', component: Main },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'el-icon-s-home',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Treść' }
  },
  {
    path: '/events/items',
    component: Home,
    iconCls: 'fa fa-calendar',
    meta: { label: 'Wydarzenia' },
    children: [
      {
        path: '',
        component: getView('Events/EventList'),
        name: 'Event List',
        meta: { label: 'Lista wydarzeń' }
      },
      {
        path: 'add',
        component: getView('Events/EventForm'),
        name: 'Add Event',
        meta: { label: 'Dodaj wydarzenie' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Events/EventForm'),
        name: 'Edit Event',
        hidden: true,
        meta: { label: 'Edytuj wydarzenie' }
      }
    ]
  },
  {
    path: '/events/tags',
    component: Home,
    iconCls: 'fa fa-hashtag',
    meta: { label: 'Wydarzenia - tagi' },
    children: [
      {
        path: '',
        component: getView('EventTags/EventTagList'),
        name: 'EventTag List',
        meta: { label: 'Lista tagów' }
      },
      {
        path: 'add',
        component: getView('EventTags/EventTagForm'),
        name: 'Add EventTag',
        meta: { label: 'Dodaj tag' }
      },
      {
        path: ':id',
        props: true,
        component: getView('EventTags/EventTagForm'),
        name: 'Edit EventTag',
        hidden: true,
        meta: { label: 'Edytuj tag' }
      }
    ]
  },
  {
    path: '/articles/items',
    component: Home,
    iconCls: 'fa fa-newspaper-o',
    meta: { label: 'Aktualności' },
    children: [
      {
        path: '',
        component: getView('Articles/ArticleList'),
        name: 'Article List',
        meta: { label: 'Lista aktualności' }
      },
      {
        path: 'add',
        component: getView('Articles/ArticleForm'),
        name: 'Add Article',
        meta: { label: 'Dodaj aktualność' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Articles/ArticleForm'),
        name: 'Edit Article',
        hidden: true,
        meta: { label: 'Edytuj aktualność' }
      }
    ]
  },
  {
    path: '/articles/tags',
    component: Home,
    iconCls: 'fa fa-hashtag',
    meta: { label: 'Aktualności - tagi' },
    children: [
      {
        path: '',
        component: getView('ArticleTags/ArticleTagList'),
        name: 'ArticleTag List',
        meta: { label: 'Lista tagów' }
      },
      {
        path: 'add',
        component: getView('ArticleTags/ArticleTagForm'),
        name: 'Add ArticleTag',
        meta: { label: 'Dodaj tag' }
      },
      {
        path: ':id',
        props: true,
        component: getView('ArticleTags/ArticleTagForm'),
        name: 'Edit ArticleTag',
        hidden: true,
        meta: { label: 'Edytuj tag' }
      }
    ]
  },
  {
    path: '/forms',
    component: Home,
    iconCls: 'fa fa-vcard',
    meta: { label: 'Formularze' },
    children: [
      {
        path: '',
        component: getView('CustomForms/CustomFormsList'),
        name: 'CustomForms List',
        meta: { label: 'Lista formularzy' }
      },
      {
        path: 'add',
        component: getView('CustomForms/CustomForm'),
        name: 'Add CustomForm',
        meta: { label: 'Dodaj formularz' }
      },
      {
        path: ':id',
        component: getView('CustomForms/CustomForm'),
        name: 'Edit CustomForm',
        hidden: true,
        meta: { label: 'Edytuj formularz' }
      }
    ]
  },
  {
    path: '/logotypes',
    component: Home,
    iconCls: 'fa fa-trademark',
    meta: { label: 'Logotypy' },
    children: [
      {
        path: '',
        component: getView('Logotypes/LogotypesList'),
        name: 'Logotypes List',
        meta: { label: 'Lista logotypów' }
      },
      {
        path: 'add',
        component: getView('Logotypes/LogotypesForm'),
        name: 'Add Logotypes',
        meta: { label: 'Dodaj logotypy' }
      },
      {
        path: ':id',
        component: getView('Logotypes/LogotypesForm'),
        name: 'Edit Logotypes',
        props: true,
        hidden: true,
        meta: { label: 'Edytuj logotypy' }
      }
    ]
  },
  {
    path: '/pages',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Podstrony' },
    children: [
      {
        path: '',
        component: getView('Pages/PagesList'),
        name: 'Pages List',
        meta: { label: 'Lista stron' }
      },
      {
        path: 'add',
        component: getView('Pages/PageForm'),
        name: 'Add Page',
        meta: { label: 'Dodaj stronę' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Pages/PageForm'),
        name: 'Edit Page',
        hidden: true,
        meta: { label: 'Edytuj stronę' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Pliki' }
  },
  {
    path: '/images',
    component: Home,
    iconCls: 'fa fa-image',
    meta: { label: 'Zdjęcia' },
    children: [
      {
        path: '',
        component: getView('Image/ImageList'),
        name: 'Image List',
        meta: { label: 'Lista zdjęć' }
      },
      {
        path: 'add',
        component: getView('Image/ImageForm'),
        name: 'Add Image',
        meta: { label: 'Dodaj zdjęcie' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Image/ImageForm'),
        name: 'Edit Image',
        hidden: true,
        meta: { label: 'Edytuj zdjęcie' }
      }
    ]
  },
  {
    path: '/attachments',
    component: Home,
    iconCls: 'fa fa-download',
    meta: { label: 'Załączniki' },
    children: [
      {
        path: '',
        component: getView('Attachments/AttachmentsList'),
        name: 'Attachments List',
        meta: { label: 'Lista załączników' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Konfiguracja Strony' }
  },
  {
    path: '/menu',
    component: Home,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [
      {
        path: '',
        component: getView('Menus/MenusList'),
        name: 'Menus List',
        meta: { label: 'Lista menu' },
        hidden: true
      },
      {
        path: 'main-menu',
        props: {
          default: true,
          id: 'main-menu'
        },
        component: getView('Menus/MenuForm'),
        name: 'Edit Menu',
        meta: { label: 'Edytuj menu główne' }
      }
    ]
  },
  {
    path: '/users',
    component: Home,
    iconCls: 'fa fa-group',
    meta: { label: 'Użytkownicy' },
    children: [
      {
        path: '',
        component: getView('User/UserList'),
        name: 'User List',
        meta: { label: 'Lista użytkowników' }
      },
      {
        path: 'add',
        component: getView('User/UserForm'),
        name: 'Add User',
        meta: { label: 'Dodaj użytkownika' }
      },
      {
        path: ':id',
        props: true,
        component: getView('User/UserForm'),
        name: 'Edit User',
        hidden: true,
        meta: { label: 'Edytuj użytkownika' }
      }
    ]
  },
  {
    path: '/settings',
    component: Home,
    iconCls: 'fa fa-cog',
    meta: { label: 'Ustawienia' },
    children: [
      {
        path: '',
        component: getView('Settings/SettingsForm'),
        name: 'Settings Form',
        meta: { label: 'Konfiguracja strony' }
      }
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - Panel administracyjny`
    : 'Panel administracyjny'
  next()
})

export default router
